/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type CancelSubscriptionAccountMutationVariables = Types.Exact<{
  input: Types.CancelSubscriptionInput;
}>;


export type CancelSubscriptionAccountMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'CancelSubscriptionResponse', error?: { __typename?: 'ErrorGrowth', description?: string | null, type: Types.ErrorTypeGrowth } | null } };

export type ListUserSubscriptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListUserSubscriptionsQuery = { __typename?: 'Query', listUserSubscriptions: { __typename?: 'ListUserSubscriptionsResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, subscriptions: Array<{ __typename?: 'CFSubscription', id: string, status: string, statusCode: string, name: string, nextPaymentDate?: string | null, discountedPrice?: string | null, totalAmount: string, totalAmountFormatted?: string | null, canBeCancelled?: boolean | null, isActivating?: boolean | null, billingPeriod?: string | null, currency?: string | null, stripeUrl?: string | null }> } };

export type GetUserSubscriptionQueryVariables = Types.Exact<{
  subscriptionId: Types.Scalars['String']['input'];
}>;


export type GetUserSubscriptionQuery = { __typename?: 'Query', getUserSubscription: { __typename?: 'GetUserSubscriptionResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, subscription?: { __typename?: 'CFSubscription', id: string, status: string, statusCode: string, name: string, endDate?: string | null, nextPaymentDate?: string | null, discountedPrice?: string | null, totalAmount: string, totalAmountFormatted?: string | null, canBeCancelled?: boolean | null, isActivating?: boolean | null, billingPeriod?: string | null, currency?: string | null, stripeUrl?: string | null, totalAccessibleProducts?: number | null, leavingList: Array<{ __typename?: 'CFSubscriptionLeavingList', count?: number | null, label: string }> } | null } };

export type ListUserOrdersQueryVariables = Types.Exact<{
  cursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListUserOrdersQuery = { __typename?: 'Query', listUserOrders: { __typename?: 'ListUserOrdersResponse', nextCursor?: string | null, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, orders: Array<{ __typename?: 'CFOrder', id: string, date?: string | null, status: string, total: string, needsPayment?: boolean | null, paymentUrl?: string | null }> } };


export const CancelSubscriptionAccountDocument = `
mutation cancelSubscriptionAccount($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    error {
      description
      type
    }
  }
}

`

export const cancelSubscriptionAccountMutationKey = 'cancelSubscriptionAccount'

export function cancelSubscriptionAccountMutationFetcher(variables: CancelSubscriptionAccountMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<CancelSubscriptionAccountMutation, CancelSubscriptionAccountMutationVariables>(CancelSubscriptionAccountDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useCancelSubscriptionAccountMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<CancelSubscriptionAccountMutation, E, CancelSubscriptionAccountMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<CancelSubscriptionAccountMutation, E, CancelSubscriptionAccountMutationVariables, C>({
        ...options,
        mutationKey: [cancelSubscriptionAccountMutationKey],
        mutationFn: (variables: CancelSubscriptionAccountMutationVariables) => cancelSubscriptionAccountMutationFetcher(variables, fetchOptions),
    })
}

export const ListUserSubscriptionsDocument = `
query listUserSubscriptions {
  listUserSubscriptions(input: {limit: 1, page: 1}) {
    error {
      type
      description
    }
    subscriptions {
      id
      status
      statusCode
      name
      nextPaymentDate
      discountedPrice
      totalAmount
      totalAmountFormatted
      canBeCancelled
      isActivating
      billingPeriod
      currency
      stripeUrl
    }
  }
}

`

export const listUserSubscriptionsQueryRootKey = 'listUserSubscriptions'

export function listUserSubscriptionsQueryFetcher(variables?: ListUserSubscriptionsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListUserSubscriptionsQuery, ListUserSubscriptionsQueryVariables>(ListUserSubscriptionsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function listUserSubscriptionsQueryKey(variables?: ListUserSubscriptionsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [listUserSubscriptionsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function listUserSubscriptionsQueryOptions(
    variables?: ListUserSubscriptionsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListUserSubscriptionsQuery, unknown, ListUserSubscriptionsQuery, (ListUserSubscriptionsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: listUserSubscriptionsQueryKey(variables, fetchOptions),
        queryFn: listUserSubscriptionsQueryFetcher(variables, fetchOptions),
    }
}

export function useListUserSubscriptionsQuery<D = ListUserSubscriptionsQuery, E = unknown>(
    variables?: ListUserSubscriptionsQueryVariables,
    options?: Omit<UseQueryOptions<ListUserSubscriptionsQuery, E, D, (ListUserSubscriptionsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListUserSubscriptionsQuery, E, D, (ListUserSubscriptionsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...listUserSubscriptionsQueryOptions(variables, fetchOptions),
    })
}

export const GetUserSubscriptionDocument = `
query getUserSubscription($subscriptionId: String!) {
  getUserSubscription(input: {subscriptionId: $subscriptionId}) {
    error {
      type
      description
    }
    subscription {
      id
      status
      statusCode
      name
      endDate
      nextPaymentDate
      discountedPrice
      totalAmount
      totalAmountFormatted
      canBeCancelled
      isActivating
      billingPeriod
      currency
      stripeUrl
      totalAccessibleProducts
      leavingList {
        count
        label
      }
    }
  }
}

`

export const getUserSubscriptionQueryRootKey = 'getUserSubscription'

export function getUserSubscriptionQueryFetcher(variables: GetUserSubscriptionQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetUserSubscriptionQuery, GetUserSubscriptionQueryVariables>(GetUserSubscriptionDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function getUserSubscriptionQueryKey(variables: GetUserSubscriptionQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [getUserSubscriptionQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function getUserSubscriptionQueryOptions(
    variables: GetUserSubscriptionQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetUserSubscriptionQuery, unknown, GetUserSubscriptionQuery, (GetUserSubscriptionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: getUserSubscriptionQueryKey(variables, fetchOptions),
        queryFn: getUserSubscriptionQueryFetcher(variables, fetchOptions),
    }
}

export function useGetUserSubscriptionQuery<D = GetUserSubscriptionQuery, E = unknown>(
    variables: GetUserSubscriptionQueryVariables,
    options?: Omit<UseQueryOptions<GetUserSubscriptionQuery, E, D, (GetUserSubscriptionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetUserSubscriptionQuery, E, D, (GetUserSubscriptionQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...getUserSubscriptionQueryOptions(variables, fetchOptions),
    })
}

export const ListUserOrdersDocument = `
query listUserOrders($cursor: String) {
  listUserOrders(input: {limit: 20, cursor: $cursor}) {
    error {
      type
      description
    }
    orders {
      id
      date
      status
      total
      needsPayment
      paymentUrl
    }
    nextCursor
  }
}

`

export const listUserOrdersQueryRootKey = 'listUserOrders'

export function listUserOrdersQueryFetcher(variables?: ListUserOrdersQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListUserOrdersQuery, ListUserOrdersQueryVariables>(ListUserOrdersDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function listUserOrdersQueryKey(variables?: ListUserOrdersQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [listUserOrdersQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function listUserOrdersQueryOptions(
    variables?: ListUserOrdersQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListUserOrdersQuery, unknown, ListUserOrdersQuery, (ListUserOrdersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: listUserOrdersQueryKey(variables, fetchOptions),
        queryFn: listUserOrdersQueryFetcher(variables, fetchOptions),
    }
}

export function useListUserOrdersQuery<D = ListUserOrdersQuery, E = unknown>(
    variables?: ListUserOrdersQueryVariables,
    options?: Omit<UseQueryOptions<ListUserOrdersQuery, E, D, (ListUserOrdersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListUserOrdersQuery, E, D, (ListUserOrdersQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...listUserOrdersQueryOptions(variables, fetchOptions),
    })
}